import { css, cx, etiColors } from '@eti/styles';
import { Icon } from '@eti/components';
import { jsx as _jsx } from "react/jsx-runtime";
const iconTypeStyle = iconType => iconType === 'remove' ? css`
        height: 0.75rem;
        width: 0.75rem;

        @media (min-width: 48em) {
          height: 0.875rem;
          margin-top: 1px;
          width: 0.875rem;
        }
      ` : css`
        height: 0.875rem;
        width: 0.875rem;

        @media (min-width: 48em) {
          height: 1rem;
          width: 1rem;
        }
      `;
const highlightedStyle = isHighlighted => css`
  fill: ${isHighlighted ? etiColors.white : etiColors.grayScale[6]};
`;
const SummaryEditSeatIcon = _ref => {
  let {
    isHighlighted,
    iconType = 'edit'
  } = _ref;
  return /*#__PURE__*/_jsx(Icon, {
    className: cx(iconTypeStyle(iconType), highlightedStyle(isHighlighted)),
    id: iconType === 'remove' ? 'close' : 'edit'
  });
};
export default SummaryEditSeatIcon;